var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Tooltip } from '@dixa/lib-shared-habla';
import { shallowEqual } from 'react-redux';
import { analytics } from 'app/utils/segment';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { actions } from 'components/conversation/actions/conversation';
import { getLatestFacebookConversation } from 'components/conversation/selectors';
import { canClaimConversation } from 'components/conversation/utils/canClaimConversation';
import { canTakeOverConversation } from 'components/conversation/utils/canTakeOverConversation';
import { useCommandHandler } from 'utils/commands';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
const { conversationClaim } = actions;
export const ConversationClaimButton = () => {
    const dispatch = useAppDispatch();
    const { conversation, isAssignedToMe, latestFacebookCsid, asyncStatus } = useAppSelector((state) => ({
        conversation: state.conversation.metaConversation.conversation,
        isAssignedToMe: state.conversation.metaConversation.isAssignedToMe,
        latestFacebookCsid: getLatestFacebookConversation(state),
        asyncStatus: state.conversation.asyncStatus,
    }), shallowEqual);
    const canTakeOver = canTakeOverConversation(conversation, isAssignedToMe);
    const canClaim = canClaimConversation(conversation, isAssignedToMe, latestFacebookCsid);
    const isDisabled = !canClaim && !canTakeOver;
    useCommandHandler({
        name: 'conversation:claim',
        actionFn: () => {
            if (isDisabled) {
                return;
            }
            claimConversation();
        },
    });
    const claimConversation = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        yield bindActionToPromise(dispatch, conversationClaim)({
            csid: conversation.id,
        });
        analytics.conversationClaimed({
            conversationId: (_a = conversation.id) !== null && _a !== void 0 ? _a : 0,
            location: 'conversation',
            type: canClaim ? 'claim' : 'takeOver',
            channel: (conversation === null || conversation === void 0 ? void 0 : conversation.initial_channel) || undefined,
            language: (_b = conversation === null || conversation === void 0 ? void 0 : conversation.attributes) === null || _b === void 0 ? void 0 : _b.language,
            tags: conversation.tags,
        });
    });
    const titles = canTakeOver
        ? {
            loading: 'Taking over...',
            button: 'Take over conversation',
        }
        : {
            loading: 'Claiming...',
            button: 'Claim conversation',
        };
    const tooltipContent = (_jsx(CommandKeybindingsTooltipContent, Object.assign({ commandName: "conversation:claim" }, { children: titles.button })));
    return (_jsx(Tooltip, Object.assign({ disabled: asyncStatus.claim === 'loading', content: tooltipContent, dark: true }, { children: _jsx(Button, Object.assign({ variant: "primary", isLoading: asyncStatus.claim === 'loading', loadingIndicator: titles.loading, onClick: claimConversation, disabled: isDisabled }, { children: titles.button })) })));
};
